import { css } from 'aphrodite';
import * as React from 'react';
import { useContext } from 'react';
import { ViewportContext } from '../../../hooks/useViewport';
import { ILeaderboard } from '../../../viewModels/gamification';
import { ProgressBar } from '../../ProgressBar';
import { styleSheet } from '../styles';
import { SortOptions } from './ListHeader';

export interface IProps {
	selected?: SortOptions;
	totals: ILeaderboard;
}

export const TotalScores: React.FC<IProps> = ({ selected, totals }) => {
	const { isBelowSmall } = useContext(ViewportContext);

	const goal = isBelowSmall ? totals?.totalGoals?.[selected] : totals?.totalGoals?.demos;

	const amount = isBelowSmall ? totals?.totalScore?.[selected] : totals?.totalScore?.demos;

	const projected = isBelowSmall ? totals?.projectedScore?.[selected] : totals?.projectedScore?.demos;

	// Get the appropriate title based on the selected column
	let title = 'Demo totals';
	if (isBelowSmall) {
		if (selected === SortOptions.Dials) {
			title = 'All dials';
		} else if (selected === SortOptions.ProspectingDials) {
			title = 'Prospect dials';
		} else if (selected === SortOptions.Points) {
			title = 'Points';
		} else if (selected === SortOptions.Connections) {
			title = 'Connections';
		} else if (selected === SortOptions.Demos) {
			title = 'Demos';
		} else {
			title = 'Totals';
		}
	}

	return (
		<div className={css(styleSheet.totals)}>
			<span className={css(styleSheet.totalsTitle)}>{title}</span>
			<ProgressBar goal={goal} amount={amount} projected={projected} label={`${title} toward today's goal`} />
		</div>
	);
};
